import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'civilianTime'
})
export class CivilianTimePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    value = value || '';
    const regexp = new RegExp('^[0-2][0-9]:[0-5][0-9]$');

    if (!regexp.test(value)) { // input was not in proper format, just return it unmodified
      return value;
    }
    let hours: string = value.substring(0, 2);
    const suffix = Number(hours) >= 12 ? 'PM' : 'AM';
    hours = String(((Number(hours) + 11) % 12 + 1));
    return hours + ':' + value.substring(3) + ' ' + suffix;
  }
}
